import React, { useEffect, useState, Fragment } from 'react';
import { getVATStatus } from '../Services/VAT.service';
import { translate } from '../Services/translation';

const FooterVATToggle = () => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = React.createRef();
    const [VATstatus, setVATStatus] = useState(false);

    useEffect(() => {        
        setVATStatus(getVATStatus());        
    }, []);


    const toggleVAT = (status) => {
        setVATStatus(status);
        document.cookie = `IncludeVat=${status}; path=/; max-age=2592000; SameSite=Lax`;
        location.href = location.href;
    }

    return (<Fragment>
        <h4 className='footer__header'>{translate('footer.vattoggle.header')}</h4>
        <div className="product-selector__content">
            <div ref={dropdownRef} className="custom-dropdown-wrapper" style={{ position: 'relative' }}>
                <button
                    type="button"
                    className="configurator-variants"
                    id="vatfilter"
                    data-filter="sizefilter"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {VATstatus ? translate('footer.vattoggle.private') : translate('footer.vattoggle.company')}
                </button>
                <span className={`dropdown-arrow ${isOpen ? 'arrow-up' : 'arrow-down'}`}>
                    <svg className="svg-arrow" style={{ color: '#000' }}><use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use></svg>
                </span>
                {isOpen && (
                    <ul className="custom-dropdown-options">
                        <li key="private" onClick={() => { toggleVAT(true); setIsOpen(false); }} className={`custom-dropdown-item ${VATstatus ? 'is-active' : ''}`}>
                            {translate('footer.vattoggle.private')}
                        </li>
                        <li key="company" onClick={() => { toggleVAT(false); setIsOpen(false); }} className={`custom-dropdown-item ${!VATstatus ? 'is-active' : ''}`}>
                            {translate('footer.vattoggle.company')}
                        </li>
                    </ul>
                )}
            </div>
        </div>
    </Fragment>);
}

export default FooterVATToggle;